import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Relationships } from '../models/relationships';

@Injectable()
export abstract class ModelFactory<M extends {}> {
  protected abstract resourceName: string;
  protected abstract resourceNamePlural: string;
  protected abstract Model: { new(m: any): M };
  protected abstract extractResourceStrategy: (body: any) => any;
  protected abstract buildResourceStrategy: (model: M) => any;
  protected abstract relationships: Relationships;

  public toModel(body: any | any[]): M | M[] {
    let resource = this.extractResourceStrategy(body);
    if (_.isArray(resource)) {
      return _.map(resource, r => {
        return new this.Model(this.buildFromResource(r));
      });
    } else {
      return new this.Model(this.buildFromResource(resource));
    }
  }

  public toResource(model: M): any {
    return this.buildResourceStrategy(model);
  }

  protected platformControllerExtractResourceStrategy(body: any): any {
    if (!!body[this.resourceName] && !_.isArray(body[this.resourceName])) {
      return body[this.resourceName];
    } else if (!!body[this.resourceNamePlural]) {
      return body[this.resourceNamePlural];
    }
  }

  protected enrichApiExtractResourceStrategy(body: any): any {
    return body.result;
  }

  protected platformControllerBuildResourceStrategy(model: M): any {
    return _.mapKeys(model, (value, key) => _.snakeCase(key));
  }

  private buildFromResource(resource: any, recursive: boolean = true): any {
    let object = {};
    for (let property of Object.keys(resource)) {
      let camelCaseProperty = _.camelCase(property);
      if (recursive && camelCaseProperty in this.relationships) {
        let relationship = this.relationships[camelCaseProperty];
        if (relationship.toMany) {
          object[camelCaseProperty] = _.map(resource[property], relatedResource => {
            return new relationship.Model(this.buildFromResource(relatedResource, false));
          });
        } else {
          object[camelCaseProperty] = new relationship.Model(this.buildFromResource(resource[property], false));
        }
      } else {
        object[camelCaseProperty] = resource[property];
      }
    }
    return object;
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/factories/model-factory.service.ts